export const clickOutside = {
  mounted(el, binding, vNode) {
    const vm = vNode.context;
    const callback = binding.value;
    el.clickOutsideEvent = function (event) {
      if (!(el == event.target || el.contains(event.target) )) {
        callback(vm, event);
      }
    };
    
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  
  unmounted (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  }
}
